import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    if (this.seenInSession()) return
    this.open()
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    document.documentElement.classList.remove("overflow-hidden")
    document.body.classList.remove("overflow-hidden")
    sessionStorage.setItem("constructionNoticeSeen", "true")
  }

  seenInSession() {
    return sessionStorage.getItem("constructionNoticeSeen") === "true"
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.documentElement.classList.add("overflow-hidden")
    document.body.classList.add("overflow-hidden")
  }
}
